module.exports = __webpack_public_path__ + "static/media/kr.94941e04.svg";